"use client";

import { FC, ReactNode } from "react";
import style from "./style.module.scss";
import Image from "next/image";
import { GENERAL } from "@/constants";

type Props = {
  label: string;
  value: string;
  iconSrc?: string;
};

const ForecastDetailsItem: FC<Props> = ({ label, value, iconSrc }) => {
  return (
    <div className={style.foreCastDetailsItem}>
      <div className={style.labelContainer}>
        {iconSrc && <Image src={iconSrc} alt={label} width={GENERAL.IMAGE_SIZES.LARGE} height={GENERAL.IMAGE_SIZES.LARGE} />}
        <p className={style.metarDetailsItemInfoLabel}>{label}</p>
      </div>
      <p className={style.metarDetailsItemInfoLabel}>{value}</p>
    </div>
  );
};

export default ForecastDetailsItem;


